import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48b9b6c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_5 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_6 = {
  key: 3,
  class: "invalid-feedback"
}
const _hoisted_7 = {
  key: 4,
  class: "invalid-feedback"
}
const _hoisted_8 = {
  key: 5,
  class: "invalid-feedback"
}
const _hoisted_9 = {
  key: 6,
  class: "invalid-feedback"
}
const _hoisted_10 = {
  key: 7,
  class: "invalid-feedback"
}
const _hoisted_11 = {
  key: 8,
  class: "invalid-feedback"
}
const _hoisted_12 = {
  key: 9,
  class: "invalid-feedback"
}
const _hoisted_13 = {
  key: 10,
  class: "invalid-feedback"
}
const _hoisted_14 = {
  key: 11,
  class: "invalid-feedback"
}
const _hoisted_15 = {
  key: 12,
  class: "invalid-feedback"
}
const _hoisted_16 = {
  key: 13,
  class: "invalid-feedback"
}
const _hoisted_17 = {
  key: 14,
  class: "invalid-feedback"
}
const _hoisted_18 = {
  key: 15,
  class: "invalid-feedback"
}
const _hoisted_19 = {
  key: 16,
  class: "invalid-feedback"
}
const _hoisted_20 = {
  key: 17,
  class: "invalid-feedback"
}
const _hoisted_21 = {
  key: 18,
  class: "invalid-feedback"
}
const _hoisted_22 = {
  key: 19,
  class: "invalid-feedback"
}
const _hoisted_23 = {
  key: 20,
  class: "invalid-feedback"
}
const _hoisted_24 = {
  key: 21,
  class: "invalid-feedback"
}
const _hoisted_25 = {
  key: 22,
  class: "invalid-feedback"
}
const _hoisted_26 = {
  key: 23,
  class: "invalid-feedback text-center"
}
const _hoisted_27 = {
  key: 24,
  class: "invalid-feedback"
}
const _hoisted_28 = {
  key: 25,
  class: "invalid-feedback"
}
const _hoisted_29 = {
  key: 26,
  class: "invalid-feedback"
}
const _hoisted_30 = {
  key: 27,
  class: "invalid-feedback"
}
const _hoisted_31 = {
  key: 28,
  class: "invalid-feedback"
}
const _hoisted_32 = {
  key: 29,
  class: "invalid-feedback"
}
const _hoisted_33 = {
  key: 30,
  class: "invalid-feedback"
}
const _hoisted_34 = {
  key: 31,
  class: "invalid-feedback"
}
const _hoisted_35 = {
  key: 32,
  class: "invalid-feedback"
}
const _hoisted_36 = {
  key: 33,
  class: "invalid-feedback"
}
const _hoisted_37 = {
  key: 34,
  class: "invalid-feedback"
}
const _hoisted_38 = {
  key: 35,
  class: "invalid-feedback"
}
const _hoisted_39 = {
  key: 36,
  class: "invalid-feedback"
}
const _hoisted_40 = {
  key: 37,
  class: "invalid-feedback"
}
const _hoisted_41 = {
  key: 38,
  class: "invalid-feedback"
}
const _hoisted_42 = {
  key: 39,
  class: "invalid-feedback"
}
const _hoisted_43 = {
  key: 40,
  class: "invalid-feedback"
}
const _hoisted_44 = {
  key: 41,
  class: "invalid-feedback"
}
const _hoisted_45 = {
  key: 42,
  class: "invalid-feedback"
}
const _hoisted_46 = {
  key: 43,
  class: "invalid-feedback"
}
const _hoisted_47 = {
  key: 44,
  class: "invalid-feedback"
}
const _hoisted_48 = {
  key: 45,
  class: "invalid-feedback"
}
const _hoisted_49 = {
  key: 46,
  class: "invalid-feedback"
}

import { translate } from '@/languages/i18n'
import { DEFAULT_MAX_LENGTH, DEFAULT_MIN_LENGTH } from '@/constants/number'
import { VALIDATOR_MAX_LENGTH_NO_SUBJECT, VALIDATOR_PAIR_REQUIRED_NO_SUBJECT } from '@/constants/validate'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: String,
  message: {
    type: String,
    default: null,
  },
  params: {
    type: Array,
    default: () => [DEFAULT_MIN_LENGTH, DEFAULT_MAX_LENGTH],
  },
  validator: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.validator === 'required')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.message), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(translate)('requiredInput', __props.title, __props.params)), 1))
        ]))
      : _createCommentVNode("", true),
    (__props.validator === _unref(VALIDATOR_PAIR_REQUIRED_NO_SUBJECT))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(translate)('requiredInputNoSubject')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'requiredSelect')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(translate)('requiredSelect', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'requiredDate')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 送信日時指定してください。 "))
      : _createCommentVNode("", true),
    (__props.validator === 'maxLength' || __props.validator === 'minLength')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(translate)('minMaxString', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === _unref(VALIDATOR_MAX_LENGTH_NO_SUBJECT))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(translate)('minMaxStringNoSubject', '', __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'maxNum')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(translate)('maxNum', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'maxString')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(translate)('maxString', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'requiredDetails')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('requiredDetails', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'requiredInquiryContent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(translate)('inquiryContentDetails')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'requiredEmailReply')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(translate)('requiredEmailReply')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'email')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(translate)('validateMail', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'containsSpecialWords')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(translate)('passwordSpecialWords', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'containsType')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(translate)('passwordHaveType', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'pictograms')
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(translate)('validatePictograms')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'sameAsPassword')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(translate)('confirmPasswordNotMatch', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'sameAsEmail')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(translate)('confirmEmailNotMatch', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'fullSizeKatakana')
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(translate)('fullSizeKatakana', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'maxDate')
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(translate)('maxDate', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'minDate')
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(__props.params[2] ? _unref(translate)('minDate', __props.title, __props.params) : _unref(translate)('minDateMonth', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'afterStartDate')
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(translate)('afterStartDateWork', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'afterStartDateHour')
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(translate)('afterStartDateHour', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'maxDateNyears')
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(translate)('maxDateNyears', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'agreeWithTerm')
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(translate)('mustAgree', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'checkTypeImage')
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(translate)('validateTypeImage', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'fileSizeValidation')
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(translate)('validateFileSize', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'emoji')
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(translate)('validateEmoji', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'ngWord')
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'containsSpace')
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(translate)('passwordHaveType', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'afterAvailableType')
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(translate)('passwordHaveType', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'pastDate')
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(translate)('pastDate', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'textAreaMaxLength')
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(translate)('minMaxString', __props.title, __props.params)), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'notUseCurrentPass')
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 変更前とは異なる値を入力してください。 "))
      : _createCommentVNode("", true),
    (__props.validator === 'containsTypeSpecialCharacter')
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, " 使用できない文字列が含まれています。 "))
      : _createCommentVNode("", true),
    (__props.validator === 'ownedPoint')
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(translate)('VALIDATE_OWNED_POINTS')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'urlCannotBeUsed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(translate)('ERROR_INVITATION_GROUP_URL_CANNOT_BE_USED')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'urlNotFound')
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(translate)('ERROR_INVITATION_GROUP_URL_NOT_FOUND')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'inputUrl')
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_unref(translate)('VALIDATE_NOT_INPUT_URL')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'validUrl')
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_unref(translate)('VALIDATE_INVALID_URL')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'numeric')
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_unref(translate)('validateNumber')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'withoutContent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_unref(translate)('VALIDATE_WITHOUT_CONTENT')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'limitMention')
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_unref(translate)('VALIDATE_NUMBER_OF_MENTION')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'sameTagValidation')
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(translate)('VALIDATE_SAME_TAGS')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'postMaxTagValidation')
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_unref(translate)('CK20TagDescription2')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'errorOccurred')
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_unref(translate)('ERROR_MENTION_USER_INVALID')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'editorMaxNumberOfImage')
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_unref(translate)('VALIDATE_MAX_UPLOAD_IMAGE')), 1))
      : _createCommentVNode("", true),
    (__props.validator === 'checkFileExtension')
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref(translate)('ERROR_UPLOAD_FILE_FORMAT')), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})